import type { PaletteOptions } from '@mui/material';
import { dataVizColors } from '../shared/dataVizualization';
import { primitives } from '../shared/primitives';
import type { PortalExtendedPalette } from '../types';
import { v4Gradients } from './gradients';
import { muiV4Palette } from './mui-palette';
import { v4Semantic } from './semantic';

export const v4ExtendedPalette: PaletteOptions & PortalExtendedPalette = {
  ...muiV4Palette,

  primitives,
  dataViz: dataVizColors,
  semantic: v4Semantic,
  gradients: v4Gradients,
};
